import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AppService, AppSettingService } from '../../app.service';
//import { ActionIconComponent } from '../../territoryCard/action-icon.component';

@Component({
	selector: 'app-action-icon-open-folder',
	templateUrl: "./action-icon-open-folder.component.html"
	//template: `<app-signup-login  *ngIf="isReady" [display]="display" [prefillUsername]="prefillUsername" [allowCancel]="allowCancel" (onCloseSL)="closeSL($event)"><app-signup-login>`
	//template: `<app-action-icon [fontAwesomeIconClass]="fa solid fa folder" [toolTip]="snarf tooltip" (selected)="onSelected()"><app-action-icon>`,
})
export class ActionIconOpenFolderComponent implements OnInit {
	@Input() isMobile: boolean = false;
	@Input() folderData: any;
	constructor(
		private router: Router
	) { }
	onSelected() {		
		this.router.navigateByUrl("/FileManagement?topFolderId=" + this.folderData.FolderId);
	}

	ngOnInit(): void {		
	}
}
